import * as Bixby from '$/core';

export abstract class DraftCompanyService {
  private static baseUrl = Bixby.Constants.API_COMPANYCONTROLLER;
  private static adminBaseUrl = `${Bixby.Constants.API_ADMIN_PREFIX}/${Bixby.Constants.API_ACTION_COMPANY}`;
  private static draft = Bixby.Constants.API_PARAMS_DRAFT;

  // Client
  public static async get(companyId: string): Promise<Bixby.Models.Company> {
    const route = Bixby.API.ServerRoute.forAction(
      `${DraftCompanyService.baseUrl}/${companyId}/${DraftCompanyService.draft}`
    );
    return await Bixby.API.get(route);
  }

  public static async getDraftFinancialStatement(
    companyId: string,
    statementType: Bixby.Enums.FinancialStatementType
  ): Promise<string[]> {
    const route = Bixby.API.ServerRoute.forAction(
      `${DraftCompanyService.baseUrl}/${companyId}/${DraftCompanyService.draft}/${statementType}`
    );
    return await Bixby.API.get(route);
  }

  public static async exportDraftFinancialStatements(companyId: string): Promise<Blob> {
    const route = Bixby.API.ServerRoute.forAction(
      `${DraftCompanyService.baseUrl}/${companyId}/${DraftCompanyService.draft}/${Bixby.Constants.API_ACTION_DOWNLOAD}`
    );
    return await Bixby.API.getFile(route);
  }

  // Admin
  public static async adminGetById(companyId: string): Promise<Bixby.Models.DraftCompany> {
    const route = Bixby.API.ServerRoute.forAction(
      `${DraftCompanyService.adminBaseUrl}/${companyId}/${DraftCompanyService.draft}`
    );
    return await Bixby.API.get(route);
  }

  public static async create(companyId: string): Promise<Bixby.Models.AdminCompany> {
    const route = Bixby.API.ServerRoute.forAction(
      `${DraftCompanyService.adminBaseUrl}/${companyId}/${DraftCompanyService.draft}`
    );
    return await Bixby.API.post(route, null);
  }

  public static async delete(companyId: string): Promise<void> {
    const route = Bixby.API.ServerRoute.forAction(
      `${DraftCompanyService.adminBaseUrl}/${companyId}/${DraftCompanyService.draft}`
    );
    return await Bixby.API.delete(route);
  }

  public static async update(companyId: string, jsonPatchOperation: Bixby.Models.JsonPatchOperation[]): Promise<void> {
    const route = Bixby.API.ServerRoute.forAction(
      `${DraftCompanyService.adminBaseUrl}/${companyId}/${DraftCompanyService.draft}`
    );
    return await Bixby.API.patchJSON(route, jsonPatchOperation);
  }

  public static async publish(companyId: string): Promise<Bixby.Models.AdminCompany> {
    const route = Bixby.API.ServerRoute.forAction(
      `${DraftCompanyService.adminBaseUrl}/${companyId}/${DraftCompanyService.draft}/${Bixby.Constants.API_ACTION_PUBLISH}`
    );
    return await Bixby.API.post(route, null);
  }
}
